var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"source-button"},[_c('a',{attrs:{"href":("" + (_vm.meta ? _vm.sourceURL(_vm.meta.path, _vm.meta.file, _vm.meta.line) : _vm.sourceURL(_vm.path))),"title":"Source"}},[_c('em',{staticClass:"fa fa-code"})])])}
var staticRenderFns = []

export { render, staticRenderFns }